var _style, _linearGradient, _linearGradient2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 64.69 23.9",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 98 40.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 14.34,
    y1: 13.59,
    x2: 50.16,
    y2: 13.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#791169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#DD449C"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 14.35,
    y1: 13.59,
    x2: 50.16,
    y2: 13.59
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 14.34,
    y1: 13.59,
    x2: 50.16,
    y2: 13.59
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2828275186608"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id2)",
    d: "M63.4 10.02c0.39,-0.46 0.71,-1.01 0.95,-1.65 0.23,-0.63 0.35,-1.36 0.35,-2.15 0,-0.84 -0.14,-1.63 -0.43,-2.35 -0.29,-0.73 -0.7,-1.38 -1.24,-1.92 -0.54,-0.54 -1.2,-0.97 -1.97,-1.26 -0.76,-0.29 -1.61,-0.44 -2.54,-0.44l-5.71 0c-0.72,0 -1.35,0.26 -1.86,0.78 -0.51,0.51 -0.77,1.14 -0.77,1.86l0 12.9c0,0.66 0.24,1.23 0.7,1.69 0.47,0.47 1.03,0.7 1.69,0.7 0.67,0 1.25,-0.24 1.72,-0.7 0.48,-0.47 0.72,-1.04 0.72,-1.7l0 -3.6 1.49 -0 2.62 4.77c0.22,0.38 0.51,0.68 0.87,0.89 0.37,0.22 0.77,0.33 1.2,0.33 0.72,0 1.32,-0.27 1.76,-0.78 0.42,-0.48 0.63,-1.03 0.63,-1.62 0,-0.39 -0.1,-0.77 -0.31,-1.18l-1.85 -3.13c0.22,-0.09 0.44,-0.21 0.65,-0.33 0.49,-0.29 0.93,-0.67 1.32,-1.13zm-4.06 -2.68c-0.35,0.29 -0.78,0.44 -1.33,0.44l-3.01 0 0 -3.1 3.01 0c0.55,0 0.99,0.14 1.33,0.44 0.32,0.27 0.46,0.62 0.46,1.12 0,0.49 -0.15,0.85 -0.46,1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id1)",
    d: "M12.73 8.56c-0.49,-0.41 -1.06,-0.75 -1.69,-1.01 -0.59,-0.25 -1.2,-0.46 -1.81,-0.63 -0.6,-0.17 -1.19,-0.32 -1.77,-0.44 -0.54,-0.12 -1.03,-0.25 -1.45,-0.39 -0.37,-0.12 -0.67,-0.27 -0.88,-0.43 -0.12,-0.09 -0.14,-0.16 -0.14,-0.26 0,-0.28 0.1,-0.48 0.34,-0.66 0.28,-0.21 0.73,-0.32 1.34,-0.32 0.56,0 1.12,0.07 1.69,0.2 0.55,0.13 1.1,0.35 1.61,0.64 0.89,0.52 1.98,0.43 2.84,-0.23 0.53,-0.41 0.82,-0.99 0.82,-1.68 0,-0.47 -0.15,-0.89 -0.44,-1.25 -0.29,-0.37 -0.7,-0.7 -1.23,-0.98 -0.48,-0.25 -1.01,-0.46 -1.57,-0.63 -0.56,-0.17 -1.14,-0.29 -1.74,-0.37 -0.59,-0.08 -1.14,-0.12 -1.63,-0.12 -1.04,0 -1.99,0.14 -2.83,0.43 -0.85,0.29 -1.58,0.7 -2.18,1.21 -0.6,0.52 -1.07,1.13 -1.4,1.81 -0.33,0.69 -0.5,1.44 -0.5,2.23 0,0.88 0.16,1.64 0.48,2.26 0.31,0.61 0.73,1.14 1.25,1.56 0.49,0.4 1.06,0.74 1.69,0.99 0.59,0.24 1.2,0.45 1.81,0.62 0.6,0.17 1.2,0.32 1.78,0.44 0.54,0.12 1.02,0.25 1.44,0.39 0.37,0.13 0.65,0.28 0.86,0.45 0.12,0.1 0.17,0.21 0.17,0.37 0,0.12 -0.03,0.24 -0.1,0.36 -0.07,0.13 -0.18,0.25 -0.33,0.35 -0.17,0.12 -0.4,0.22 -0.69,0.3 -0.3,0.08 -0.67,0.12 -1.08,0.12 -0.73,0 -1.41,-0.11 -2.03,-0.32 -0.63,-0.22 -1.21,-0.5 -1.69,-0.83 -0.2,-0.15 -0.43,-0.26 -0.68,-0.32 -0.81,-0.2 -1.62,-0.02 -2.25,0.55 -0.47,0.43 -0.73,1 -0.73,1.67 0,0.43 0.13,0.84 0.38,1.21 0.29,0.43 0.7,0.81 1.24,1.13 0.49,0.29 1.06,0.54 1.69,0.73 0.61,0.19 1.26,0.34 1.94,0.45 0.67,0.1 1.33,0.16 1.95,0.16 1.17,0 2.21,-0.15 3.1,-0.44 0.91,-0.3 1.68,-0.71 2.29,-1.24 0.62,-0.53 1.09,-1.17 1.4,-1.91 0.3,-0.72 0.46,-1.51 0.46,-2.36 0,-0.87 -0.16,-1.64 -0.48,-2.26 -0.31,-0.61 -0.73,-1.14 -1.24,-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id0)",
    d: "M45 1.27c-3.76,-1.86 -8.47,-0.93 -11.03,2.18 -1.37,1.66 -1.96,1.63 -3.43,-0.07 -2.4,-2.77 -5.5,-3.49 -8.94,-2.79 -3.12,0.63 -5.26,2.53 -6.2,5.62 -0.38,1.24 -0.48,2.5 -0.36,3.7l-0.05 0 0 5.65 0 6.24c0,1.16 0.94,2.11 2.11,2.11 1.16,0 2.11,-0.94 2.11,-2.11l0 -5.49c0.02,0.01 0.04,0.03 0.07,0.04 3.94,2.08 8.71,1.18 11.44,-2.16 1.15,-1.41 2.02,-1.42 3.11,-0.05 1.77,2.23 4.1,3.28 6.92,3.27 4.34,0.03 7.67,-2.43 8.58,-6.33 0.96,-4.11 -0.77,-8.05 -4.32,-9.8zm-3.97 12.35c-2.34,0 -4.27,-1.78 -4.52,-4.06l-8.03 0 -0.04 0.07c-0.27,2.25 -2.18,3.99 -4.51,3.99 -2.51,0 -4.54,-2.03 -4.54,-4.54 0,-2.51 2.03,-4.54 4.54,-4.54 2.19,0 4.01,1.54 4.44,3.6l8.2 0.01c0.27,-1.29 1.09,-2.38 2.21,-3.02 0.45,-0.35 1.01,-0.52 1.61,-0.54 0.21,-0.03 0.42,-0.05 0.63,-0.05 2.51,0 4.54,2.03 4.54,4.54 -0,2.51 -2.03,4.54 -4.54,4.54z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorLogo);
export default __webpack_public_path__ + "static/media/colorLogo.32a23e77e1818460cb4bd17c0efe1ae9.svg";
export { ForwardRef as ReactComponent };